export default __webpack_public_path__ + "img/benefits5.6112c9d9.svg";